import React from 'react';
import './UpcomingWorkshop.css';

const UpcomingWorkshop = () => {
  const workshops = [
    {
      id: 1,
      title: '6 Two-Day Pre-Summit Regional Infrastructure, Climate, Security & Green Investment Stakeholder Engagement Workshops',
      strategicObjective: 'Identify and structure bankable sub-national projects aligned with the Nigeria National Development Plan, Energy Transition Plan, Climate Change Act, AfCFTA Action Plan, AU Agenda 2063 and ECOWAS priorities. Strengthen state-level PPP replication frameworks.',
      venue: 'The proposed state is accepting to host AICIS 2026 PRE-EVENT. 6 Host-state opportunity collaboration with the federal government and organizers.',
      date: 'Regional Workshop Schedule',
      schedule: [
        { region: 'South West', location: 'Ibadan', date: '16–17 June 2026' },
        { region: 'North Central', location: 'Abuja (OSGF)', date: '29–30 June 2026' },
        { region: 'North West', location: 'Kano', date: '8–9 July 2026' },
        { region: 'North East', location: 'Yola', date: '5–6 August 2026' },
        { region: 'South South', location: 'Akwa Ibom', date: '26–27 August 2026' },
        { region: 'South East', location: 'Enugu', date: '9–10 September 2026' }
      ],
      sectors: 'Renewable Energy; Climate Adaptation; Transport; Agro-industry; Health Infrastructure; Digital Governance; Security Technology',
      outcomes: '4 Communiqués — 20–40 Bankable Concept Notes'
    }
  ];

  return (
    <div className="workshop-page">
      <section 
        className="workshop-hero" 
        style={{
        //   backgroundImage: `linear-gradient(135deg, rgba(43, 15, 5, 0.9) 0%, rgba(74, 51, 38, 0.75) 50%, rgba(43, 15, 5, 0.9) 100%), url('/images/aicis-2026-bg.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="workshop-hero-overlay"></div>
        <div className="workshop-hero-content">
          <span className="workshop-badge">AICIS 2026</span>
          <h1>Regional Stakeholder Engagement Workshops</h1>
          <p className="workshop-subtitle">Pre-Summit Infrastructure, Climate, Security & Green Investment Workshops</p>
          <div className="workshop-hero-stats">
            <div className="stat-item">
              <span className="stat-number">6</span>
              <span className="stat-label">Workshops</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">6</span>
              <span className="stat-label">Regions</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">40+</span>
              <span className="stat-label">Bankable Concepts</span>
            </div>
          </div>
        </div>
      </section>

      <section className="workshop-section">
        <div className="container">
          {workshops.map((workshop) => (
            <div className="workshop-detail-card" key={workshop.id}>
              <div className="workshop-header">
                <div className="workshop-icon">🏛️</div>
                <h2>{workshop.title}</h2>
              </div>

              <div className="workshop-grid">
                <div className="workshop-info-block">
                  <div className="info-icon">🎯</div>
                  <h3>Strategic Objective</h3>
                  <p>{workshop.strategicObjective}</p>
                </div>

                <div className="workshop-info-block">
                  <div className="info-icon">📍</div>
                  <h3>Venue</h3>
                  <p>{workshop.venue}</p>
                </div>
              </div>

              <div className="workshop-schedule">
                <h3>📅 Regional Workshop Schedule</h3>
                <div className="schedule-grid">
                  {workshop.schedule.map((item, index) => (
                    <div className="schedule-card" key={index}>
                      <div className="schedule-region">{item.region}</div>
                      <div className="schedule-location">{item.location}</div>
                      <div className="schedule-date">{item.date}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="workshop-outcomes">
                <div className="outcomes-sectors">
                  <h3>🎯 Targeted Sectors</h3>
                  <div className="sector-tags">
                    {workshop.sectors.split('; ').map((sector, idx) => (
                      <span className="sector-tag" key={idx}>{sector}</span>
                    ))}
                  </div>
                </div>
                <div className="outcomes-results">
                  <h3>📊 Expected Outcomes</h3>
                  <div className="outcome-badge">{workshop.outcomes}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="workshop-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Partner?</h2>
            <p>Interested in hosting or participating in the AICIS 2026 Pre-Summit Workshops?</p>
            <button className="btn-gold" onClick={() => window.location.href = '/partnership-collaboration'}>
              Express Interest Now
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default UpcomingWorkshop;